export enum CollateralType {
    broadlySyndicated = 'BroadlySyndicated',
    middleMarket = 'MiddleMarket',
}
